import { IDashboardCounts } from "../../Model/Dashboard";
import api from "../../api";

export const getDashboardCounts = async (): Promise<IDashboardCounts> => {
  const response = await api.get(`/admin/dashboard`);
  const counts = response.data;
  return counts;
};
